import { createMiddleware } from 'redux-beacon';

import { COOKIE_CONSENT_GRANTED } from '../actions/UI';

/**
 * Load additional tags after consent.
 * @return {object} Event that triggers loading of additional tags.
 */
const cookieConsentGranted = () => {
  return {
    event: 'Cookie consent granted',
  };
};

// Map events to a Redux actions
const eventsMap = {
  [COOKIE_CONSENT_GRANTED]: cookieConsentGranted,
};

export default createMiddleware(eventsMap);
